import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { Roles } from '@enums/roles.enum';

/**
 * Verhindert Zugriff auf Rechnungen für die Rolle Account.
 */
@Injectable({
  providedIn: 'root'
})
export class NoAccountInvoicesGuard implements CanActivate {

  constructor(private authenticationService: AuthenticationService, private router: Router) { }

  canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authenticationService.userHasRole(Roles.Account)) {
      this.router.navigate(['/forbidden']);
      return false;
    }
    return true;
  }
}
